export default "/images/400fb9b806dc797f6b1a6ffe398d960f.avif";